module.exports = __webpack_public_path__ + "img/warning_co2.705c4c9d.svg";